import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { colorStore } from '@/features/queueColors';
import {
  DonutData,
  ProjectDistributionMode,
  TProjectDistributionMode,
} from '@/features/TimeStatsModel';

import { useTimeStatsModel } from '../../TimeStatsModel';
import { getChartColorByIndex } from '../constants';

import { TimePieChart } from './TimePieChart';

import s from './ProjectDistributionChart.module.scss';

export const ProjectDistributionChart: React.FC = observer(() => {
  const { projectDistributionChartData, projectDistributionMode, estimationLoadingStage } =
    useTimeStatsModel();

  const needsTaskDetails =
    projectDistributionMode.value === ProjectDistributionMode.parent ||
    projectDistributionMode.value === ProjectDistributionMode.epic;
  const isTaskDetailsLoading =
    needsTaskDetails && (estimationLoadingStage.isLoading || estimationLoadingStage.isNotStarted);

  const getColor = needsTaskDetails
    ? (_: DonutData, index: number) => getChartColorByIndex(index)
    : (item: DonutData) => colorStore.getColorByPrefix(item.colorKey ?? item.name);

  return (
    <>
      <div className={s.project_distribution__header}>
        <h2>Распределение по проектам</h2>
        <ToggleButtonGroup
          exclusive
          size="small"
          value={projectDistributionMode.value}
          onChange={(_, value: TProjectDistributionMode | null) => {
            if (value !== null) {
              projectDistributionMode.change(value);
            }
          }}
          className={s.project_distribution__toggle}
        >
          <ToggleButton
            value={ProjectDistributionMode.project}
            className={s.project_distribution__toggle_btn}
          >
            Проекты
          </ToggleButton>
          <ToggleButton
            value={ProjectDistributionMode.parent}
            className={s.project_distribution__toggle_btn}
          >
            Род. задачи
          </ToggleButton>
          <ToggleButton
            value={ProjectDistributionMode.epic}
            className={s.project_distribution__toggle_btn}
          >
            Эпики
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      <TimePieChart
        data={projectDistributionChartData}
        getColor={getColor}
        isLoading={isTaskDetailsLoading}
      />
    </>
  );
});
